const Director=[
    {
        
            "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841159/aces/team/Faculty_Advisor_Sapan_Sir_kvet8g.jpg',
            "text":'',
            "name":'xyz',
            "position":'Director'
          
    }
]

const Chairman=[
    {
        
            "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841159/aces/team/Faculty_Advisor_Sapan_Sir_kvet8g.jpg',
            "text":'',
            "name":'xyz',
            "position":'Chairman'
          
    }
]

const Faculty_Advisor=[
    {
        
            "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841159/aces/team/Faculty_Advisor_Pooja_Shah_depfvz.jpg',
            "text":'',
            "name":'Pooja Shah',
            "position":'Faculty Advisor'
          
    },
    {
        
            "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841159/aces/team/Faculty_Advisor_Sapan_Sir_kvet8g.jpg',
            "text":'',
            "name":'Sapan_Sir',
            "position":'Faculty Advisor'
          
    },
]


const board_members=[

    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841021/aces/team/Kanisha_Shah_ej5luq.jpg',
        "text":'',
        "name":'Kanisha Shah',
        "position":'President'
    },
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841011/aces/team/Meet_Vora_y5sf7m.jpg',
        "text":'',
        "name":'Meet Vora',
        "position":'Vice President'
    },
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841012/aces/team/Kunj_Thakkar_gbi2kb.jpg',
        "text":'',
        "name":'Kunj Thakkar',
        "position":'General Secretary'
    },
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841017/aces/team/Naman_Thaker_jwdrqy.jpg',
        "text":'',
        "name":'Naman Thaker',
        "position":'Managing Director'
    },
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841010/aces/team/Sachi_Chaudhary_ey8wej.jpg',
        "text":'',
        "name":'Sachi Chaudhary',
        "position":'Marketing Director '
    },
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841018/aces/team/Akshat_Shah_dc9epe.jpg',
        "text":'',
        "name":'Akshat Shah',
        "position":'Organizing Secretary'
    },
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841010/aces/team/Mrunal_Shah_ufwjux.jpg',
        "text":'',
        "name":'Mrunal Shah',
        "position":'Director General'
    },
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841010/aces/team/Shivam_Panchal_v8p28u.jpg',
        "text":'',
        "name":'Shivam Panchal',
        "position":'Technical Head'
    },
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841011/aces/team/Yagnik_Thummar_psxapj.png',
        "text":'',
        "name":'Yagnik Thummar',
        "position":'Technical Head'
    },
   
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841014/aces/team/Kalp_Mepani_vh2gvy.jpg',
        "text":'',
        "name":'Kalp Mepani',
        "position":'Treasurer'
    },
   
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640846014/aces/team/Yash_Savani_yyuoxq.jpg',
        "text":'',
        "name":'Yash Savani',
        "position":'Editor'
    },
   
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841014/aces/team/Sakariya_Gaurav_dxoytf.jpg',
        "text":'',
        "name":'Sakariya Gaurav',
        "position":'Creative Head'
    },
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841024/aces/team/Ansh_Ray_c0spwt.jpg',
        "text":'',
        "name":'Ansh Ray',
        "position":'Public Relations Officer'
    },
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841015/aces/team/Aayush_Shah_tlu5ip.jpg',
        "text":'',
        "name":'Aayush Shah',
        "position":'Graphic Designer'
    },
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841023/aces/team/Savan_Vaghani_oliarn.png',
        "text":'',
        "name":'Savan Vaghani',
        "position":'Membership Chair'
    },
   
    {
        "url":'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841012/aces/team/Manan_Patel_ywgdyn.jpg',
        "text":'',
        "name":'Manan Patel',
        "position":'Joint Secretary'
    },
   

]

export {board_members,Director,Faculty_Advisor,Chairman};